import toast from 'react-hot-toast';
// import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import config from '../../../config';
import {
  setAuthToken,
  setRefreshToken,
  setDeviceIdentity,
  removeAuthToken,
  removeRefreshToken,
  removeDeviceIdentity,
} from '../../utils/auth';
import { getItem } from '../../utils/localStorageFn';

const registerPriceFlow = () => {
  // const dispatch = useDispatch();
  const history = useHistory();

  const updatePriceSettings = ({
    paywallPrice,
    tipJarPriceLow,
    tipJarPriceMedium,
    tipJarPriceHigh,
    changeModalText,
    setShowModal,
  }) => {
    const publisherData = JSON.parse(getItem('publisherdata'));
    const publisherId = publisherData.id;
    const userData = JSON.parse(getItem('userdata'));
    const { accessToken } = userData;

    setShowModal(true);
    changeModalText('Setting your default prices...');

    (async () => {
      try {
        const payload = {
          paywallPrice,
          tipJarPrice: [tipJarPriceLow, tipJarPriceMedium, tipJarPriceHigh],
        };

        const response = await fetch(
          `${config.ApiBaseUrl}/publisher/${publisherId}/updatePriceSetting`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify(payload),
          }
        );

        const json = await response.json();
        const { success } = json;

        if (success) {
          setAuthToken(userData.accessToken);
          setRefreshToken(userData.refreshToken);
          setDeviceIdentity(userData.deviceKey);

          setShowModal(false);
          history.push('/registerpaywall');
        }
      } catch (e) {
        setShowModal(false);
        toast.error(e.message);

        removeAuthToken();
        removeRefreshToken();
        removeDeviceIdentity();

        console.log(e);
      }
    })();
  };

  return updatePriceSettings;
};

export default registerPriceFlow;
